"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenceTemplateStatus = void 0;
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var LicenceTemplateStatus;
(function (LicenceTemplateStatus) {
    LicenceTemplateStatus["ACTIVE"] = "ACTIVE";
    LicenceTemplateStatus["INACTIVE"] = "INACTIVE";
})(LicenceTemplateStatus = exports.LicenceTemplateStatus || (exports.LicenceTemplateStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGljZW5jZS10ZW1wbGF0ZS5lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpY2VuY2UtdGVtcGxhdGUvdHlwZXMvbGljZW5jZS10ZW1wbGF0ZS5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOzs7Ozs7R0FNRztBQUNILElBQVkscUJBR1g7QUFIRCxXQUFZLHFCQUFxQjtJQUMvQiwwQ0FBaUIsQ0FBQTtJQUNqQiw4Q0FBcUIsQ0FBQTtBQUN2QixDQUFDLEVBSFcscUJBQXFCLEdBQXJCLDZCQUFxQixLQUFyQiw2QkFBcUIsUUFHaEMifQ==